import { Component, Prop, h, Fragment } from '@stencil/core';
import { isDirRtl, isWhiteBackground } from '@utils/utils';

@Component({
  tag: 'vs-marquee',
  styleUrls: {
    default: './vs-marquee.css',
    custom: './vs-marquee-custom.css'
  },
  shadow: false,
})
export class VsMarquee {
  /**
   @shortDescription If true, enable the component.
   @controlName enabled
   */
  @Prop() enabled: boolean;

  /**
   @shortDescription If true, align the component to the right.
   @controlName right
   */
  @Prop() right: boolean = isDirRtl();

  /**
   @shortDescription The index of the component (if there are multiple components on the same page).
   @controlName index
   */
  @Prop() index: string;

  /**
   @shortDescription If true, display white text.
   @controlName isWhiteText
   */
  @Prop() isWhiteText: boolean;

  /**
   @shortDescription The background color of the box.
   @controlName boxBackgroundColor
   */
  @Prop() boxBackgroundColor: string;

  /**
   @shortDescription The URL of the background image.
   @controlName backgroundImageUrl
   */
  @Prop() backgroundImageUrl: string;

  /**
   @shortDescription The URL of the mobile background image.
   @controlName mobileBackgroundImageUrl
   */
  @Prop() mobileBackgroundImageUrl: string;

  /**
   @shortDescription The heading to display in the component.
   @controlName heading
   */
  @Prop() heading: string;

  /**
   @shortDescription The description to display in the component.
   @controlName description
   */
  @Prop() description: string;

  /**
   @shortDescription The path of the link to display in the component.
   @controlName linkPath
   */
  @Prop() linkPath: string;

  /**
   @shortDescription The text to display for the link in the component.
   @controlName linkText
   */
  @Prop() linkText: string;

  /**
   @shortDescription Style mode of the component
   @controlName mode */
  @Prop() mode: string;

  handleMarqueeClickEvent = () => {
    const customEvent = new CustomEvent("click_tracking", {
      detail: {
        componentType: "text",
        component: "Marquee",
        eventAction: "link_click",
        siteSection: "global promotion",
        clickText: this.linkText,
        imageLabel: "",
        clickCategory1: this.heading,
        clickCategory2: "",
      }
    });
    document.dispatchEvent(customEvent);
    console.log('custom event', customEvent);
  }


  render() {
    return (
      <Fragment>
        <slot name='main'>
          <div class={`vs-marquee vs-mb-0 ${!this.enabled ? 'vs-d-none' : ''}`}
               id={this.index}>
            <div class='vs-marquee-wrapper' dir={this.right ? 'rtl' : ''}>
              <ul class='vs-marquee-content vs-col-12 vs-px-0' role='none'>
                <li>
                  <div class='vs-marquee-item'>
                    <div class='vs-marquee-media-wrapper'>
                      <div class='vs-img-wrapper vs-position-relative'>
                        {this.backgroundImageUrl ?
                          <img
                            class='vs-d-none vs-d-lg-block vs-img-fluid vs-col-12 vs-px-0'
                            src={this.backgroundImageUrl}
                            loading='lazy'
                            alt=''
                          /> :
                          <div class='vs-skeleton-image-placeholder' />
                        }
                        {this.mobileBackgroundImageUrl ?
                          <img
                            class='vs-d-lg-none vs-img-fluid vs-col-12 vs-px-0'
                            src={this.mobileBackgroundImageUrl}
                            loading='lazy'
                            alt=''
                          /> :
                          <div class='vs-skeleton-mobile-image-placeholder' />
                        }
                      </div>
                    </div>
                    <div class='vs-marquee-content-wrapper vs-secondary vs-content-wrapper-padding'
                         style={{ backgroundColor: this.boxBackgroundColor, right: '3%' }}>
                      <slot name='box'>{this.heading ? (
                        <h1 class={`vs-marquee-box-heading vs-h2 ${this.isWhiteText ? 'vs-alt' : ''}`} innerHTML={this.heading} />
                      ) : (
                        <Fragment>
                          <h1 class='vs-marquee-box-heading vs-h2 vs-skeleton vs-title-skeleton' />
                          <h2 class='vs-marquee-box-heading vs-h2 vs-skeleton vs-title-skeleton' />
                        </Fragment>
                      )
                      }
                        {this.description ? (
                            <p class={`vs-marquee-box-desc vs-text ${this.isWhiteText ? 'vs-alt' : ''}`} innerHTML={this.description} />
                          ) :
                          (
                            <Fragment>
                              <p class='vs-skeleton vs-marquee-box-desc' />
                              <p class='vs-skeleton vs-marquee-box-desc' />
                              <p class='vs-skeleton vs-marquee-box-desc' />
                            </Fragment>
                          )}
                        {this.linkPath && (
                          <a href={this.linkPath}
                             onClick={this.handleMarqueeClickEvent}
                             class={`vs-marquee-box-link vs-btn vs-btn-icon ${isWhiteBackground(this.boxBackgroundColor) ? 'vs-btn-primary' : ''}`}
                             innerHTML={this.linkText} />
                        )}</slot>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </slot>
      </Fragment>
    );
  }
}
